<template>
 <!-- Modal -->
  <div class="content-box-gray card modal fade" id="display-video-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header title text-center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="myModalLabel" v-html="videoTitle" ></h4>
        </div>
        <div class=" content modal-body">
          <div class="embed-responsive embed-responsive-16by9">
            <!-- <iframe id="video1" class="embed-responsive-item"  width="640" height="564" frameborder="0" src="https://player.vimeo.com/570780298" allow="autoplay; fullscreen" allowfullscreen></iframe>	-->
            <iframe id="video1" :src="videoURL" width="640" height="564" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
            <!-- <object id="video1" data='https://www.youtube.com/embed/nfk6sCzRTbM?autoplay=1' width='560px' height='315px'></object>
		-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../event-bus';
export default {
    components:{

     },
    name: "VideoDisplayModal",
    data() {
        return {
            videoURL:'',
            videoTitle:'',
        }
    },

    props: {
    },
    mounted() {

// Listen for changes in translation content.  TODO BELOW THROWS AN ERROR ON SAVING translation.vue
        EventBus.$on('displayVideoModal', (data) => {
            // console.log("videoURL: " + data.workout.videourl);
            // console.log("video Title: " + data.workout.movementname);
            this.videoURL = data.workout.videourl;
            this.videoTitle = data.workout.movementname;
            $('div#display-video-modal').modal('show');
        });

    },
    methods: {
cancel() {
 $('div#display-video-modal').modal('hide');
    },

    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#ffc107;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}

</style>
